export default __webpack_public_path__ + "static/media/project_approval.02a9de9a.svg";